import { cloneDeep, assign } from 'lodash';
import optionsMigrations from '@/store/migrations/optionsMigrations';
import { migrate } from '@/versioning';
import dl from '@/dataLayer';

export default {
    namespaced: true,
    state: {
        //  these values will be overwritten!
        //  on first start, we run the migration stack;
        //  on subsequent loads, we pull from storage.
        //  set default values in the migrations!
        showArchived: false,
        showCompleted: false,
        startNextDay: 0,
        showWeekNumbers: false,
        firstDayOfWeek: 0,
        localeKey: null,
        theme: 0,

        //  don't set the version here
        //  let the migration handle it the first time
        //  if we don't get it from storage
        version: 0,
    },
    actions: {
        async update({commit, state}, options) {
            commit('update', options);
            await dl.set('options', state);
        },
        
        async boot({dispatch, state, rootState}) {
            const options = await dl.get('options') ?? cloneDeep(state);
            migrate('options', options, optionsMigrations);
            if (rootState.locales[options.localeKey] == null)
                options.localeKey = null;
            
            await dispatch('update', options);
        },
    },
    mutations: {
        update(state, valuesObj) {
            assign(state, valuesObj);
        },

        clear(state) {
            for (const key of Object.keys(state))
                delete state[key];
        },
    },
};